var Node = require('./node');

/* Now just crude implementation -- could just have nodes ... ? */

function Tree( root ) {

    this.root = root || new Node({
        isRoot: true,
        rowLevel: 0
    });

}


_.extend( Tree.prototype, {

    getRoot: function() {
        return this.root;
    },

    walkDown: function( callback ) {

        this.getRoot().walkDown( callback );

    }

});

module.exports = Tree;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/hierarchy/tree.js
 ** module id = 668
 ** module chunks = 0
 **/